<template>
    <pg-page title="De Private Gym Coaches"
             header="Onze Coaches"
             subtitle=""
             id="coaches"
    >
        <div class="row">
            <div class="col my-1 py-1 text-center">
                <em class="px-6">
                    Bij Private Gym kan je ervoor kiezen om je doelen te bereiken met behulp van een personal trainer. Wil je alleen wat technieken leren? Dat kan ook!  We stellen onze coaches hieronder aan je voor, en koppelen je graag aan de coach die bij je past.
                </em>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/tobias.jpg" class="card-img" alt="Private Gym - Tobias">
                    <h3 class="mt-3">
                        Tobias
                    </h3>
                    <div class="text p-2">
                        Wat je niveau, leeftijd of doel ook is; Tobias helpt anderen graag en krijgt er energie van als resultaten behaald worden. En wij ook :-) Heb je een blessure? Tobias weet je dan goed te adviseren hoe je correct en effectief kan blijven trainen.
                        <br/><br/>
                        <strong>SPECIALISMES:</strong> Kettlebell + correct en effectief trainen
                    </div>
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/zeno.png" class="card-img" alt="Private Gym - Zeno">
                    <h3 class="mt-3">
                        Zeno
                    </h3>
                    <div class="text p-2">
                        Zeno is meer dan ervaren te noemen als het gaat om de transformatie van een lichaam. Hij heeft recent namelijk zilver gewonnen op het WK Natural Bodybuilden. Ervaren in de sportschool dus, dat kunnen we wel concluderen ;-) En al zijn kennis deelt hij graag met je tijdens een personal training zodat ook jij je sportdoelen weet te bereiken!
                        <br/><br/>
                        <strong>SPECIALISME:</strong> Bodybuilding
                    </div>
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/birgit.png" class="card-img" alt="Private Gym - Birgit">
                    <h3 class="mt-3">
                        Birgit
                    </h3>
                    <div class="text p-2">
                        Bij Birgit ligt al negen jaar de focus op fitness en ze heeft zich de afgelopen jaren gespecialiseerd in hetgeen ze het leukst vindt om te doen: het trainen van de benen en billen. De kennis die ze de afgelopen jaren heeft opgedaan wil ze graag doorgeven aan anderen, en ze helpt je graag jouw doel te behalen!
                        <br/><br/>
                        <strong>SPECIALISMES:</strong> Benen & billen
                    </div>
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/joost.jpg" class="card-img" alt="Private Gym - Joost">
                    <h3 class="mt-3">
                        Joost
                    </h3>
                    <div class="text p-2">
                        Joost volgt een sportopleiding aan de ALO en geeft vaak op zondag zijn PT-lessen bij Private Gym. Hij enthousiasmeert en luistert graag naar je, om vervolgens met een passend trainingsschema te komen waarmee jij je doelen kan gaan bereiken.
                        <br/><br/>
                        <strong>SPECIALISME:</strong> Allround fitness trainer
                    </div>
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/ellen.jpg" class="card-img" alt="Private Gym - Ellen">
                    <h3 class="mt-3">
                        Ellen
                    </h3>
                    <div class="text p-2">
                        Jarenlang heeft Ellen een eigen sportschool gehad waarbij ze anderen enthousiast wist te motiveren in beweging te blijven. Na vijftien jaar heeft ze de keuze gemaakt ermee te stoppen maar haar coach-kwaliteiten zet ze graag nog een paar keer per week in bij Private Gym.
                        <br/><br/>
                        <strong>SPECIALISME:</strong> Allround fitness trainer
                    </div>
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card text-dark border-0">
                    <img src="/images/coaches/igor.png" class="card-img" alt="Private Gym - Igor">
                    <h3 class="mt-3">
                        Igor
                    </h3>
                    <div class="text p-2">
                        Igor heeft een grote passie voor krachttraining en boksen en dat heeft er ook voor gezorgd dat hij de studie Bewegingswetenschappen is gaan volgen.  Wetenschappelijk onderbouwd trainen en de meest recente bevindingen toepassen om zo effectief mogelijk te trainen. Igor weet er inmiddels alles van
                        <br/><br/>
                        <strong>SPECIALISME:</strong> Correct & effectief trainen
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Kom zelf kijken! Plan een rondleiding of stel je vraag via Whatsapp!
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="false" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>
    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import ActionButtons from "../Components/Index/ActionButtons";
export default {
    components: {ActionButtons, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>
.instagram{
    border-color: rgba(0,0,0,0);
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
}
</style>
